import { render, staticRenderFns } from "./ReportsContent.vue?vue&type=template&id=797b748c&scoped=true"
import script from "./ReportsContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsContent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReportsContent.vue?vue&type=style&index=0&id=797b748c&prod&scoped=true&lang=css"
import style1 from "./ReportsContent.vue?vue&type=style&index=1&id=797b748c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797b748c",
  null
  
)

export default component.exports